import CustomerRepository from '@/api/CustomerRepository';
import ProjectRepository from '@/api/ProjectRepository';
import ActuatorRepository from '@/api/ActuatorRepository';
import UserRepository from '@/api/UserRepository';
import AuthRepository from '@/api/AuthRepository';
import RevisionRepository from '@/api/RevisionRepository';
import ReportsRepository from '@/api/ReportsRepository';
import ContactPersonRepository from '@/api/ContactPersonRepository';

const repositories: any = {
    customer: { repository: CustomerRepository, instance: null },
    project: { repository: ProjectRepository, instance: null },
    actuator: { repository: ActuatorRepository, instance: null },
    revision: { repository: RevisionRepository, instance: null },
    user: { repository: UserRepository, instance: null },
    auth: { repository: AuthRepository, instance: null },
    reports: { repository: ReportsRepository, instance: null },
    contactPerson: { repository: ContactPersonRepository, instance: null }
};

/**
 *  Factory to create repositories. All created repositories are singleton instances.
 */
export const RepositoryFactory = {
    get: (name: string) => {
        if (repositories[name].instance) {
            return repositories[name].instance;
        } else {
            return new repositories[name].repository();
        }
    }
};
